var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pool-loading"},[_c('div',{staticClass:"ball-pulse"},[_c('div'),_c('div'),_c('div')]),_c('p',[_vm._v("Fetching feeds ...")])])}]

export { render, staticRenderFns }